// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bgg_a bhc_bi"};